module.exports = require("@material-ui/icons/DateRange");